import {Component, Reactive, VNode} from "vue";
import {AEditor} from "@/views/editor/service/editor";
import {EActivityStatus, IActivityBusinessMeta} from "@/model/activity";
import {CheckboxOptionType} from "ant-design-vue/es/checkbox/interface";
import {RadioGroupChildOption} from "ant-design-vue/es/radio/Group";
import {IInput, IRule} from "@/views/editor/service/types";

export interface INewBusiness {
    new(editor: AEditor, meta: IActivityBusinessMeta): IBusiness;
}

export interface IBusiness {
    readonly icon: () => VNode;
    readonly title: string;
    readonly description: string;
    readonly meta: IActivityBusinessMeta
    readonly preview?: string;

    implementations(status: EActivityStatus): RadioGroupChildOption[];

    subs(status: EActivityStatus): CheckboxOptionType[];

    /**
     * 新创建活动时初始化业务
     */
    resetMeta(status: EActivityStatus): IBusiness

}

export interface IBizAtmosphere extends IBusiness {
    setRules(owner: string, rules: IRule[]): void

    getBaseController(): Component
}

export interface IBizPromotion extends IBusiness {
    price(): number

    lookersListView(): { title: string, component: Component }
}

export type IBizChallenge = IBusiness

export interface IBizRaffle extends IBusiness {
    setPrizes(owner: string, prizes: unknown[]): void
}

export interface IBizCoupon extends IBusiness {
    set(owner: string, coupons: unknown[]): void
}

export interface IBizProfitSharing extends IBusiness {
    readonly active: Reactive<{ rate: { distribution: number, employee: number, cash_back: number, all: number } }>

    clearRate(): void

    shareRate(): number
}

export type IBizRedEnvelope = IBusiness


export interface IBizSign extends IBusiness {
    set(owner: string, inputs: IInput[]): void
}

export interface IBiz {
    atmosphere: IBizAtmosphere | undefined
    promotion: IBizPromotion | undefined
    challenge: IBizChallenge | undefined
    raffle: IBizRaffle | undefined
    coupon: IBizCoupon | undefined
    profit_sharing: IBizProfitSharing | undefined
    red_envelope: IBizRedEnvelope | undefined
    sign: IBizSign | undefined
}

export const emptyBiz = (): IBiz => ({
    atmosphere: undefined,
    challenge: undefined,
    coupon: undefined,
    profit_sharing: undefined,
    promotion: undefined,
    raffle: undefined,
    red_envelope: undefined,
    sign: undefined
})

export abstract class ABusiness implements IBusiness {

    abstract icon(): VNode;

    readonly abstract title: string;
    readonly abstract description: string;

    protected constructor(protected readonly editor: AEditor, readonly meta: IActivityBusinessMeta) {
    }

    abstract subs(status: EActivityStatus): CheckboxOptionType[];

    abstract implementations(status: EActivityStatus): RadioGroupChildOption[];

    abstract resetMeta(status: EActivityStatus): IBusiness

}